import { Box } from "@twilio-paste/core/box";
import { isMobile } from "react-device-detect";
import type { ResizeCallbackData } from "react-resizable";
import { ResizableBox } from "react-resizable";
import { resizeHandleStyles } from "./styles/RootContainer.styles";

type ResizableContainerProps = {
    enableDragFlag: boolean | undefined;
    enableResizeFlag: boolean | undefined;
    size: { width: number; height: number };
    onChatResize: (event: React.SyntheticEvent, { size }: ResizeCallbackData) => void;
    cssOverrides?: {
        container?: {
            width?: string;
            height?: string;
        }
    }
    getContainerHeight: (overrideHeight?: string) => string;
    getContainerWidth: (overrideWidth?: string) => string;
    configSizeFormatter: (value: string) => number;
    children: React.ReactNode;
};

export const ResizableContainer: React.FC<ResizableContainerProps> = ({
    enableDragFlag,
    enableResizeFlag,
    size,
    onChatResize,
    cssOverrides,
    getContainerHeight,
    getContainerWidth,
    configSizeFormatter,
    children,
}: ResizableContainerProps) => {

    if (enableResizeFlag && !isMobile) {
        return (
            <Box marginBottom={(enableResizeFlag && !enableDragFlag) ? "space40" : "space0"}>
                <ResizableBox
                    width={size.width}
                    height={size.height}
                    onResize={onChatResize}
                    minConstraints={[
                        configSizeFormatter(getContainerWidth(cssOverrides?.container?.width)),
                        configSizeFormatter(getContainerHeight(cssOverrides?.container?.height)),
                    ]}
                    maxConstraints={[800, 800]}
                    resizeHandles={["n"]}
                    handle={<div style={resizeHandleStyles} className="resize-handle" />}
                    axis="y"
                >
                    {children}
                </ResizableBox>
            </Box>
        );
    }

    return (
        <Box
            height={isMobile ? "100dvh" : `min(${size.height}px, 80vh)`}
            width={isMobile ? "100vw" : size.width}
            marginBottom={isMobile ? "space0" : "space40"}
            position={isMobile ? "fixed" : undefined}
            bottom={isMobile ? 0 : undefined}
            left={isMobile ? 0 : undefined}
        >
            {children}
        </Box >
    );
}
